import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
} from '@ionic/react';
import classNames from 'classnames';

import styles from './LearningCard.module.scss';

interface LearningCardProps {
  title: string;
  subtitle?: string;
  imgUrl: string;
  description?: string;
  smallTitle?: boolean;
  cardClick: () => void;
}

export default function LearningCard({
  title,
  subtitle,
  imgUrl,
  description,
  smallTitle,
  cardClick,
}: LearningCardProps) {
  return (
    <IonCard className={styles.learningCard} onClick={cardClick}>
      <img alt="Card" src={imgUrl} />
      <IonCardHeader className={styles.learningCardHeader} mode="md">
        <IonCardTitle className={classNames(styles.titleLearning, { [styles.small]: smallTitle })}>
          {title}
        </IonCardTitle>
        <p className={styles.learningDescription}>{description}</p>
      </IonCardHeader>

      {subtitle && (
        <IonCardContent
          className={styles.learningCardContent}
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      )}
    </IonCard>
  );
}
